export default __webpack_public_path__ + "static/media/singlePageWebsite.5cfaae1d.png";